import { render, staticRenderFns } from "./pddTabs.vue?vue&type=template&id=5c04b63e&scoped=true&"
import script from "./pddTabs.vue?vue&type=script&lang=js&"
export * from "./pddTabs.vue?vue&type=script&lang=js&"
import style0 from "./pddTabs.vue?vue&type=style&index=0&id=5c04b63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c04b63e",
  null
  
)

export default component.exports